import React from 'react';
import { Stack, Typography } from '@mui/material';

export const NoMatchesState: React.FC<{
  title: string;
  description: string;
}> = ({ title, description }) => (
  <Stack gap={1} alignItems="center" py="3rem" px="2rem">
    <Typography variant="h2" textAlign="center">
      {title}
    </Typography>
    <Typography variant="h5" color="text.secondary" textAlign="center">
      {description}
    </Typography>
  </Stack>
);
